import { modelsDescriptionMap } from "../../constants";

export const getModelDescriptionById = (modelId: string) => modelsDescriptionMap[modelId] || { name: modelId };
